import { CNUser } from './cnuser';
import { CNDoctor } from './cndoctor';
import { CNInsurance } from './cninsurance';
import { PatientSearchResult } from '../services/patient.service';

// export interface CNPatient {
//   firstname: string;
//   firstname2: string;
//   lastname: string;
//   initials: string;
//   address: string;
//   zip: string;
//   city: string;
//   mobile: string;
//   phone: string;
//   mutregime: string;
// }

export class CNPatient extends CNUser {

    private propMapping = {
      Lastname: 'lastname',
      Firstname: 'firstname',
      Firstname2: 'firstname2',
      Initials: 'initials',
      Birthday: 'birthdayraw',
      Sex: 'sexraw',
      Regime: 'mutregime',
      NumSIS: 'niss',
      Adresse: 'address',
      CodePostal: 'zip',
      Localite: 'city',
      Mobile: 'mobile',
      Telephone: 'phone',
      NumIC: 'cardid'
    };

    // Properties used by other objects to avoid lint errors.
    public doctor: CNDoctor;
    public insurance: CNInsurance;
    public holder: CNPatient;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNPatient';
        this.loaded.subscribe(myself => {
            for (const key of Object.keys(this.properties)) {
                let propKey = key.toLowerCase();
                if (key in this.propMapping) {
                    propKey = this.propMapping[key];
                }
                if (!this.hasOwnProperty(propKey) && !Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this), propKey)) {
                  Object.defineProperty(this, propKey, {
                    get: () => this.properties[key],
                    set: (value: any) => {
                      if (this.properties[key] !== value) {
                        this.properties[key] = value;
                      }
                    },
                  });
                }
              }
            // Load doctor
            if (!this.propertyEmpty('MedecinRef')) {
              this.odb.itemById(this.getProperty('MedecinRef')).subscribe(item => {
                this.doctor = item as CNDoctor;
              });
            }
            // // Load holder
            // if (!this.propertyEmpty('TitulaireID')) {
            //   this.odb.itemById(this.getProperty('TitulaireID')).subscribe(item => {
            //     this.holder = item as CNPatient;
            //   });
            // }
            // Load insurance
            if (!this.propertyEmpty('OAID')) {
              this.odb.itemById(this.getProperty('OAID')).subscribe(item => {
                this.insurance = item as CNInsurance;
              });
            }
        });
    }

    public clone(): any {
        return new CNPatient();
    }
}
